import React, { useState } from "react";
import IController from "@components/forms/IController";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import { Rules } from "@dashboard/settings/rules/Rules";
import { getRoute } from "@services/axios";
import { updtaSettingWithValidation } from "../Action";
import { useTranslation } from "react-i18next";

const Security = (props) => {
   const { t } = useTranslation();
  const InputSection = props.InputSection;
  const rules = new Rules(props.t);
  const [loading, setLoading] = useState(false);
  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      password: "",
      new_password: "",
      passwod_confirmation: "",
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const extraParam = {
      route: getRoute("profile_update_password"),
      t: props.t,
      title: t("enter_your_code_validation"),
      setLoading: setLoading,
    };
    await updtaSettingWithValidation(data, extraParam);
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form as="div" className="my-3"></Form>

        <InputSection
          title={props.t("password")}
          description={props.t("current_password")}
          input={
            <IController
              elment={`password`}
              item={rules.password()}
              control={control}
              errors={errors}
              register={register}
            />
          }
        />

        <hr className="border-secondary my-4" />

        <InputSection
          title={props.t("new_password")}
          description={props.t("set_new_password")}
          input={
            <IController
              elment={`new_password`}
              item={rules.password()}
              control={control}
              errors={errors}
              register={register}
            />
          }
        />

        <hr className="border-secondary my-4" />

        <InputSection
          title={props.t("passwod_confirmation")}
          description={props.t("passwod_confirmation")}
          input={
            <IController
              elment={`passwod_confirmation`}
              item={rules.password()}
              control={control}
              errors={errors}
              register={register}
            />
          }
        />
        <hr className="border-secondary my-4" />

        <InputSection
          title=""
          description=""
          input={
            <Form
              as="button"
              type="submit"
              className="btn-blue p-4 rounded-3 fw-bold w-100"
            >
              {loading ? (
                <Form
                  as="span"
                  className="spinner-border spinner-border-sm m-1 "
                ></Form>
              ) : (
                props.t("reset")
              )}
            </Form>
          }
        />
      </Form>
    </>
  );
};

export default Security;
